
import p1 from './p1.svg'
import p2 from './p2.svg'
import p3 from './p3.svg'
import p4 from './p4.svg'
import p5 from './p5.svg'
import p6 from './p6.svg'
import p7 from './p7.svg'

export const randomQuestionTheme7 = {
	p1,
	p2,
	p3,
	p4,
	p5,
	p6,
	p7,
}